<template>   
<div>
  <div class="card">
  <div class="card-body">

<div class="d-flex">
    
<div class="header-btn-actions">
 <h5 class="text-uppercase text-start fs-bold">Couriers</h5>

<div class="d-flex" v-if="actions">
    
<button
  title="Ingresar nuevo Registro"
  @click="nuevoRegistro"
  class="btn btn-primary btn-header-tabla ms-2"
>
  <i class="fas fa-plus-square"></i>
</button>

<button
  title="Refrescar Data"
  @click="getCouriers"
  class="btn btn-primary btn-header-tabla ms-2"
>
  <i class="fa-solid fa-arrows-rotate"></i>
</button>
</div>
</div>  
  <i class="fas fa-truck icon-consolidado" aria-hidden="true"></i>
  </div>


<div class="scroll-card-big mt-5">

<div class="d-flex status-control" v-if="actions">
  <button class="nav-link" :class="courierStatus == 1 ? 'text-dark' : ''" @click="courierStatus = 1">Activos</button>
  <button class="nav-link" :class="courierStatus == 0 ? 'text-dark' : ''" @click="courierStatus = 0">Inactivos</button>
</div>

<!-- Componente Data -->
<div v-if="loading">

  <div class="card w-100 mb-3" v-for="item in 3" :key="item">
        <div class="card-body">
        <div class="d-flex align-items-center justify-content-between">
            <div class="PicLoaderCircular animate din"></div>
            <div class="d-flex flex-column">
             <div class="comment br animate mb-2" style="height: 20px"></div>

          <div class="d-flex justify-content-center">

             <div class="PicLoaderCircular animate" style="width: 40px; height: 40px"></div>
              <div class="PicLoaderCircular animate ms-1" style="width: 40px; height: 40px"></div>
             </div>  

            </div>
          </div>
          </div>
    </div>


</div> <!-- end loading -->




  <div v-else class="content-courier-app">

   <div v-if="courierStatus == 1">
    
  <h5 class="text-center mt-3" v-if="couriers.length == 0">Sin couriers activos.</h5>
    
  <div  class="card w-100 mb-3 c-pointer" v-for="item in couriers"  @click="verOficinas(item)">
    
    <div class="card-body">


        <div class="row justify-content-center align-items-center">

            <div class="col-md-6">
            <h6 class="text-uppercase f-bold pe-none">{{item.nombre}}</h6>
            </div>



            <div class="col-md-6 content-courier-actions">
           <div class="d-flex flex-column">

            <img 
            class="logo-courier m-auto"
            :src="item.logo"
            @error="errorImg"
            alt="">


          <div class="d-flex justify-content-center btn-actions" v-if="actions">
              <button 
               title="Ver Oficinas"
               class="btn btn-dark b-radius">
                 <i class="fas fa-building"></i>
              </button>

              <button 
               title="Editar"
               @click="Editar(item)"
               class="btn btn-info b-radius text-white ms-1">
                 <i class="fas fa-edit"></i>
              </button>

               <button 
               v-if="$auth.user.rol === 'master'"
               title="Desactivar"
               @click="Desactivar(item)"
               class="btn btn-warning b-radius ms-1">
                 <i class="fas fa-ban"></i>
              </button>
            </div>

             </div>  
            </div>
    

            </div>

          </div>
   </div>

   </div>


   <div v-if="courierStatus == 0">
   
    <h5 class="text-center mt-3" v-if="couriersDisabled.length == 0">Sin couriers inactivos.</h5>
    
    <div  class="card w-100 mb-3 c-pointer" v-for="item in couriersDisabled"  @click="verOficinas(item)">
      
    <div class="card-body">

    <div class="row justify-content-center align-items-center">

        <div class="col-md-6">
        <h6 class="text-uppercase f-bold pe-none">{{item.nombre}}</h6>
        </div>



        <div class="col-md-6 content-courier-actions">
       <div class="d-flex flex-column">

        <img 
        class="logo-courier m-auto"
        :src="item.logo"
        @error="errorImg"
        alt="">


      <div class="d-flex justify-content-center btn-actions" v-if="actions">
          <button 
           title="Ver Oficinas"
           class="btn btn-dark b-radius">
             <i class="fas fa-building"></i>
          </button>

          <button 
           title="Editar"
           @click="Editar(item)"
           class="btn btn-info b-radius text-white ms-1">
             <i class="fas fa-edit"></i>
          </button>

           <button 
           v-if="$auth.user.rol === 'master'"
           title="Activar"
           @click="Activar(item)"
           class="btn btn-success b-radius ms-1">
             <i class="fas fa-check-circle"></i>
          </button>
        </div>

         </div>  
        </div>


        </div>

      </div>
    </div>

    </div>
    
  </div>


  </div>
<!-- Fin Componente Data -->

    </div>

 
  </div> <!-- Fin Template -->


<Modal :titulo="nombreModal" @close="toggleModal" :modalActive="modalActive" v-if="actions">
    <div>    
       <div class="row g-2 mb-3">

              <div class="col-12" v-if="modoModal==1">
                <div class="form-check">
                  <input type="checkbox" class="c-pointer" v-model="courierData.status" id="statusCourier" style="width: 20px; height: 20px;">
                  <label class="ms-2 fw-bold fs-xl-2 c-pointer" for="statusCourier">Habilitado</label>
              </div>
              </div>

              <div class="col-md-6">
            <div class="form-floating">
               <input v-model="courierData.nombre" type="text" class="form-control" id="floatingInput2" placeholder="Nombre Courier" autocomplete="off">
               <label for="floatingInput2">Nombre Courier  <span class="text-danger fw-bold">[*]</span></label>
              </div>
                </div>



              <div class="col-md-6">
             <SelectPaises :pais_select="courierData.pais" @onSetPais="courierData.pais = $event?.pais"  v-if="modalActive"/>
              </div>


              <div class="form-floating">
               <input v-model="courierData.logo" type="text" class="form-control" id="floatingInput3" placeholder="Logo Url" autocomplete="off">
               <label for="floatingInput3">Url Logo Courier (Opcional)</label>
               </div>
           

             
               <div class="form-floating">
               <input v-model="courierData.web" type="text" class="form-control" id="floatingInput4" placeholder="Web Courier" autocomplete="off">
               <label for="floatingInput4">Web Courier (Opcional)</label>
               </div>
       

              </div>
 
            </div>
          

            <div class="buttons-modal-footer">
            <button v-if="modoModal==0" @click="Crear" type="button" class="btn-modal-crear w-90 b-radius">Crear</button>
            <button v-if="modoModal==1" @click="actualizarRegistro" type="button" class="btn-modal-crear w-90 b-radius">Actualizar</button>
             </div>
            </Modal>


    <ModalConfirm @close="toggleModalConfirm" :modalActive="modalActiveConfirm" v-if="actions">
      <h5 class="text-uppercase">¿Estás seguro de <b>{{ accionConfirm === 'desactivar' ? 'desactivar' : 'activar' }}</b> el courier <b>{{ courierData.nombre }}</b>?</h5>
       <div class="buttons-modal-footer">
          <button @click="toggleModalConfirm" type="button" class="bg-dark text-white">Cancelar</button>
          <button @click="ConfirmarAccion" type="button" :class="accionConfirm === 'desactivar' ? 'btn-modal-crear bg-warning text-dark' : 'btn-modal-crear bg-success'">
            {{ accionConfirm === 'desactivar' ? 'Sí, Desactivar' : 'Sí, Activar' }}
          </button>
     </div>
   </ModalConfirm>

</div>
</template>

<script setup>
const props = defineProps({
  actions: Boolean
})
const emit = defineEmits(['courierSelected', 'success'])
import axios from 'axios'
import { useToast } from 'vue-toastification';
const toast = useToast();
import {ref, reactive, onMounted} from 'vue'
import {useLoading} from 'vue-loading-overlay'
const $loading = useLoading();
const couriers = ref([]);
const modulo = ref("courier");
const loading = ref(true)
const nombreModal = ref(null)
const modalActive = ref(false);
const modalActiveConfirm = ref(false);
import SelectPaises from '@/components/dashboard/selectPaises.vue'

const courierData = reactive({
  id: '',
  status: 1,
  nombre: '',
  logo: '',
  web: '',
  pais: ''
})

const modoModal = ref('')
const couriersDisabled = ref([])
const courierStatus = ref(1)
const accionConfirm = ref('desactivar')


const errorImg = (e) => {
    e.target.src =
      "/favicon.png";
}


const verOficinas = (item) => {
emit('courierSelected', item)
}


const nuevoRegistro = () => {
  modoModal.value = 0
  toggleModal()
}


const toggleModal = () => {
      if(modoModal.value == 0){
        nombreModal.value = 'Creacion de Courier'
      }else{
         nombreModal.value = 'Actualización Courier'
      }
      modalActive.value = !modalActive.value;
};



const getCouriers = async () => {
loading.value = true;
let response = (await axios.get(`${modulo.value}`)).data
loading.value = false
if(response.length == 0){
  return
}
couriers.value = response.filter(item => item.status == 1)
couriersDisabled.value = response.filter(item => item.status == 0)
verOficinas(couriers.value[0])
}


onMounted(async () => {
  getCouriers()
})


const toggleModalConfirm = () => {
      modalActiveConfirm.value = !modalActiveConfirm.value;
};


const Crear = async () => {
let loader = $loading.show();
try {
let response = (await axios.post(modulo.value, courierData)).data
loader.hide();
if(response.status){
    getCouriers()
    toggleModal()
    toast.success(response.mensaje)
    emit('success', courierData)
  }else{
    toast.error(response.mensaje)
  } 
} catch (error) {
  loader.hide()
  toast.error("Exeption: " + error)
}
}



const actualizarRegistro = async () => {
  let loader = $loading.show();
  try {
  let response = (await axios.put(`${modulo.value}/${courierData.id}`, courierData)).data
  loader.hide();
  if(response.status){
       getCouriers()
       toggleModal()
       toast.success(response.mensaje)
       if(courierData.status){
        courierStatus.value = 1
       }
       emit('success', courierData)
   }else{
       toast.error(response.mensaje)
    }
  } catch (error) {
    loader.hide()
    toast.error("Exeption: " + error)
}

}


const getCourierById = async (courier) => {
  /*let response = (await axios.get(`${modulo.value}/${id}`)).data
  courierData.nombre = response.nombre
  courierData.logo = response.logo
  courierData.web = response.web
  courierData.pais = response.pais
  */
 courierData.status = courier.status == 0 ? false : true
 courierData.nombre = courier.nombre
 courierData.logo = courier.logo
 courierData.web = courier.web
 courierData.pais = courier.pais
}



const Editar = (courier) => {
  modoModal.value = 1
  courierData.id = courier.id
  toggleModal()
  getCourierById(courier)
}

const Desactivar = (item) => {
  courierData.id = item.id
  courierData.nombre = item.nombre
  courierData.pais = item.pais
  courierData.logo = item.logo
  courierData.web = item.web
  accionConfirm.value = 'desactivar'
  toggleModalConfirm()
}

const Activar = (item) => {
  courierData.id = item.id
  courierData.nombre = item.nombre
  courierData.pais = item.pais
  courierData.logo = item.logo
  courierData.web = item.web
  accionConfirm.value = 'activar'
  toggleModalConfirm()
}

const ConfirmarAccion = async () => {
  let loader = $loading.show();
  try {
    const payload = {
      status: accionConfirm.value === 'activar' ? 1 : 0,
      nombre: courierData.nombre,
      pais: courierData.pais,
      logo: courierData.logo,
      web: courierData.web,
    }
    let response = (await axios.put(`${modulo.value}/${courierData.id}`, payload)).data
    loader.hide();
    if (response.status) {
      getCouriers()
      toggleModalConfirm()
      toast.success(accionConfirm.value === 'activar' ? 'Courier activado' : 'Courier desactivado')
    } else {
      toast.error(response.mensaje)
    }
  } catch (error) {
    loader.hide()
    toast.error("Exeption: " + error)
  }
}

const Eliminar = (id) => {
  courierData.id = id
  toggleModalConfirm()
}

const EliminarRegistro = async () => {
 let loader = $loading.show();
 try {
 let response = (await axios.delete(modulo.value + `/${courierData.id}`)).data
 loader.hide();
 if(response.status){
      getCouriers()
      toggleModalConfirm()
      toast.success(response.mensaje)
   }else{
      toast.error(response.mensaje)
  }
  } catch (error) {
    loader.hide()
    toast.error("Exeption: " + error)
  }
}
</script>